import style from './style.module.scss';

export const HeaderPageSpacer = () => {
    return <div className={style.headerPageSpacer}/>
}